import xhr from 'xhr';

function getTokenInputs() {
  return document.querySelectorAll('input[name="cm_token"]');
}

function updateToken(token, inputs = null) {
  if (token) {
    const tokenInputs = inputs && inputs.length ? inputs : getTokenInputs();
    for (let i=0;i<tokenInputs.length;i++) {
      tokenInputs[i].value = token;
    }
  }
}

function loadToken() {
  // Load form tokens by ajax
  const tokenInputs = getTokenInputs();
  if (tokenInputs.length) {
    xhr.get('/stage-ajax/getToken', { json: true }, function(err, resp) {
      if (resp.body) {
        updateToken(resp.body, tokenInputs);
      }
    });
  }
}

export {
  loadToken,
  updateToken
};


